<template>

  <div class="main">
    <van-overlay :show="show">
      <div class="wrapper"
           @click.stop>
        <div class="block">
          <van-loading color="#1989fa"
                       size="50px"
                       vertical>加载中...</van-loading>
        </div>
      </div>
    </van-overlay>
    <div class="m-hd">
      <span class="line"></span>
      医院药库周转分析(万)
    </div>
    <ul class="numList">
      <li>
        <div class="num">{{data.inventoryAmount/10000 |moneyP}}</div>
        <div class="tt">当日库存金额</div>
      </li>
      <li>
        <div class="num">{{data.turnoverRate |moneyP}}</div>
        <div class="tt">周转率</div>
      </li>
    </ul>
    <div id="chart_1"
         :style="{ height: '200px'}"></div>
    <!-- <ve-histogram :extend="chartExtend" :settings="chartSettings" :data="chartData" height="190px"></ve-histogram> -->
    <div class="m-hd">
      <span class="line"></span>
      医院药品销售总利润分析(万)
    </div>
    <ul class="numList2">
      <li class="item">
        <div class="num">{{data2.yearSales/10000 |moneyP}}</div>
        <div class="tt">本年销售总额 </div>
      </li>
      <li class="item2">
        <div class="num">{{data2.monthSales/10000 |moneyP}}</div>
        <div class="tt">本月销售总金额</div>
      </li>
      <li class="item3">
        <div class="num">{{data2.monthProfit/10000 |moneyP}}</div>
        <div class="tt">总利润</div>
      </li>
      <li class="item4">
        <div class="num">{{data2.monthProfitRate*100 |moneyP}}%</div>
        <div class="tt">利润率</div>
      </li>
    </ul>
    <div id="chart_2"
         :style="{ height: '200px'}"></div>
    <ul class="numList3">
      <li>

        <div class="item1">
          <div class="num">{{data2.inpatientMonthSales/10000 |moneyP}}</div>
          <div class="tt">
            <div class="round round1"></div>住院销售总额
          </div>
        </div>
        <div class="item2">
          <div class="num">{{data2.inpatientMonthProfit/10000 |moneyP}}</div>
          <div class="tt">住院总利润</div>
        </div>
        <div class="item2">
          <div class="num">{{data2.inpatientMonthProfitRate*100 |moneyP}}%</div>
          <div class="tt">利润率</div>
        </div>
      </li>
      <li>
        <div class="item1">
          <div class="num">{{data2.outpatientMonthSales/10000 |moneyP}}</div>
          <div class="tt">
            <div class="round round2"></div>门诊销售总额
          </div>
        </div>
        <div class="item2">
          <div class="num">{{data2.outpatientMonthProfit/10000 |moneyP}}</div>
          <div class="tt">门诊总利润</div>
        </div>
        <div class="item2">
          <div class="num">{{data2.outpatientMonthProfitRate*100 |moneyP}}%</div>
          <div class="tt">利润率</div>
        </div>
      </li>
    </ul>
    <div id="chart_3"
         :style="{ height: '200px'}"></div>
    <van-tabs v-model="active"
              type="card">
      <van-tab :title=date2>
        <ul class="numList4">
          <li>
            <div class="num">{{data3.rete*100 |moneyP}}%</div>
            <div class="tt">及时配送率</div>
          </li>
          <li>
            <div class="num">{{(1-data3.rete)*100 |moneyP}}%</div>
            <div class="tt">缺货率</div>
          </li>
        </ul>
      </van-tab>
      <van-tab title="本月累计">
        <ul class="numList4">
          <li>
            <div class="num">{{data4.rete*100 |moneyP}}%</div>
            <div class="tt">及时配送率</div>
          </li>
          <li>
            <div class="num">{{(1-data4.rete)*100 |moneyP}}%</div>
            <div class="tt">缺货率</div>
          </li>
        </ul>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import api from "@/axios/api";
import { moneyP2 } from "@/filter/money";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["token"])
  },
  watch: {

    token: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.getTime();
          this.turnover();
          this.sales();
          this.rate();
          this.rate2();
          //图表1
          this.getTurnover();
          //图表3
          this.getSales();
        }
      }
    }
  },
  data () {
    return {
      active: 0,
      date: this.$route.query.date,
      date2: this.$route.query.date.substring(5),
      data: {},
      data2: {},
      data3: {},
      data4: {},

      dateS: [],
      dateM: [],
      dateList: [],
      monthList: [],
      amountList: [],
      rateList: [],

      zylrList: [],
      mzlrList: [],
      //promise
      proArr: [],
      proArr2: [],
      show: true
    };
  },
  methods: {
    showOverlay () {
      alert(0)
      this.show = false;
    },
    formatDate (year, month, day) {
      const y = year;
      let m = month;
      if (m < 10) m = `0${m}`;
      let d = day;
      if (d < 10) d = `0${d}`;
      return `${y}-${m}-${d}`;
    },
    getTime () {
      let now = new Date(this.date);
      const dateList = [...Array(6).keys()].map(days => {
        let t = new Date(now - 86400000 * days);
        let year = t.getFullYear();
        let month = t.getMonth() + 1;
        let day = t.getDate();
        const str = this.formatDate(year, month, day);
        return str;
      });
      this.dateList = dateList.reverse();
      this.monthList = this.getMonth();
      this.dateS = this.dateList.map(item => {
        let time = item.substring(5).replace(/-/g, "/");
        return time;
      });
      this.dateM = this.monthList.map(item => {
        let time = item.substring(5);
        return time;
      });
    },
    getMonth () {
      let data = new Date(this.date);
      var year = data.getFullYear();
      var mon = data.getMonth() + 1;
      var arry = new Array();
      for (var i = 0; i < 6; i++) {
        if (mon <= 0) {
          year = year - 1;
          mon = mon + 12;
        }
        var mon2 = mon;
        if (mon < 10) {
          mon = "0" + mon;
        }
        arry[i] = year + "-" + mon;
        mon = mon - 1;
      }
      return arry.reverse();
    },
    turnover () {
      let param = {
        date: this.date
      };
      api.turnover(param).then(res => {
        if (res.success) {
          this.data = res.result;
        }
      });
    },
    promise (param) {
      return new Promise((resolve, reject) => {
        api
          .turnover(param)
          .then(res => {
            resolve(res.result);
          })
          .catch(err => {
            reject(err);
          });
      });
    },


    getTurnover () {
      for (let i = 0; i < this.dateList.length; i++) {
        let param = {
          date: this.dateList[i]
        };
        this.proArr.push(this.promise(param));
      }
      Promise.all(this.proArr).then(res => {
        //console.log(res);
        for (let i = 0; i < res.length; i++) {
          let a = moneyP2(res[i].inventoryAmount / 10000);
          let b = moneyP2(res[i].turnoverRate);
          this.amountList.push(a);
          this.rateList.push(b);
        }
        this.drawChart();
      });
    },

    sales () {
      let time = this.date.substring(0, 7);
      let param = {
        date: time
      };
      api.sales(param).then(res => {
        if (res.success) {
          this.data2 = res.result;
          this.drawChart2();
        }
      });
    },
    promise2 (param) {
      return new Promise((resolve, reject) => {
        api.sales(param)
          .then(res => {
            resolve(res.result);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getSales () {
      for (let i = 0; i < this.monthList.length; i++) {
        let param = {
          date: this.monthList[i]
        };
        this.proArr2.push(this.promise2(param));
      }
      Promise.all(this.proArr2).then(res => {
        //console.log(res);
        for (let i = 0; i < res.length; i++) {
          if (res[i] == null) {
            let a = 0;
            let b = 0;
            this.zylrList.push(a);
            this.mzlrList.push(b);
          } else {
            let a = moneyP2(res[i].inpatientMonthProfit / 10000);
            let b = moneyP2(res[i].outpatientMonthProfit / 10000);
            this.zylrList.push(a);
            this.mzlrList.push(b);
          }
        }
        this.drawChart3();
      });
    },
    rate () {

      let param = {
        date: this.date
      };
      api.rate(param).then(res => {
        if (res.success) {
          console.log("rate")
          this.data3 = res.result;
        }
      });
    },
    rate2 () {

      let time = this.date.substring(0, 7);
      let param = {
        date: time
      };
      api.rate(param).then(res => {
        if (res.success) {
          this.data4 = res.result;
          console.log("rate2")
        }
      });
    },
    drawChart () {
      // 基于准备好的dom，初始化echarts实例
      let chart_1 = this.$echarts.init(
        document.getElementById("chart_1")
      );
      // 绘制图表
      chart_1.setOption({
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["库存金额", "周转率"],
          textStyle: {
            //图例的公用文本样式。
            fontSize: 12,
            color: "#a6a6a6"
          }
        },
        grid: {
          x: 50,
          y: 40,
          x2: 40,
          y2: 30
        },
        xAxis: [
          {
            type: "category",
            data: this.dateS,
            axisLine: {
              lineStyle: {
                color: "#dedede"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#a6a6a6"
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "万元         ",
            //  min: 0,
            // max: 2000,
            //  interval: 200,
            axisLine: {
              lineStyle: {
                color: "#dedede"
              }
            },
            nameTextStyle: {
              color: "#a6a6a6"
            },
            axisLabel: {
              textStyle: {
                color: "#a6a6a6"
              }
            },
            axisTick: {
              show: false
            },
            //网格样式
            splitLine: {
              show: false
            }
          },
          {
            type: "value",
            name: "",
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              textStyle: {
                color: "#a6a6a6"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            //网格样式
            splitLine: {
              lineStyle: {
                color: ["#dedede"],
                width: 1,
                type: "solid"
              }
            }
          }
        ],
        series: [
          {
            name: "库存金额",
            type: "bar",
            data: this.amountList,
            barWidth: 15,
            itemStyle: {
              normal: {
                color: "#477aff"
              }
            }
          },
          {
            name: "周转率",
            type: "line",
            symbol: "circle", //设定为实心点
            symbolSize: 7.5,
            data: this.rateList,
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#ffa647"
              }
            }
          }
        ]
      });
    },
    drawChart2 () {
      // 基于准备好的dom，初始化echarts实例
      let chart_2 = this.$echarts.init(
        document.getElementById("chart_2")
      );
      let lr1 = moneyP2(this.data2.inpatientMonthProfit / 10000);
      let lr2 = moneyP2(this.data2.outpatientMonthProfit / 10000);
      chart_2.setOption({
        tooltip: {
          trigger: "item"
        },
        legend: {
          show: false
        },
        series: [
          {
            color: ["#5fc8f3", "#5791e7"],
            type: "pie",
            radius: ["57.5%", "80%"],
            label: {
              // 视觉引导的文本
              normal: {
                show: true, // 是否显示视觉引导线
                position: "outside", // 标签的位置。outside/inside/center
                color: "#989898",
                fontSize: 14,
                align: "left",
                formatter: "{name|{b}占比}\n{per|{d}%}", // 格式，支持回调
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  name: {
                    color: '#989898',
                    fontSize: 12,
                  },
                  per: {
                    color: '#2c2c2c',
                    fontWeight: 'bold',
                    lineHeight: 30,
                    fontSize: 16,
                    align: 'center'
                  }
                },
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              show: true
            },
            data: [
              { value: lr2, name: "门诊利润" },
              { value: lr1, name: "住院利润" }
            ]
          }
        ]
      });
    },
    drawChart3 () {
      // 基于准备好的dom，初始化echarts实例
      let chart_3 = this.$echarts.init(
        document.getElementById("chart_3")
      );
      chart_3.setOption({
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['住院药品利润', '门诊药品利润']
        },
        grid: {
          x: 50,
          y: 40,
          x2: 40,
          y2: 30
        },
        xAxis: [
          {
            name: "月",
            nameTextStyle: {
              color: "#a6a6a6",
              padding: [28, 0, 0, -25]    // 四个数字分别为上右下左与原位置距离
            },
            type: "category",
            data: this.dateM,
            axisLine: {
              lineStyle: {
                color: "#dedede"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#a6a6a6"
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "万元         ",
            //  min: 0,
            // max: 2000,
            //  interval: 200,
            axisLine: {
              lineStyle: {
                color: "#dedede"
              }
            },
            nameTextStyle: {
              color: "#a6a6a6"
            },
            axisLabel: {
              textStyle: {
                color: "#a6a6a6"
              }
            },
            axisTick: {
              show: false
            },
            //网格样式
            splitLine: {
              lineStyle: {
                color: ["#dedede"],
                width: 1,
                type: "solid"
              }
            }
          }
        ],
        series: [
          {
            name: "住院药品利润",
            type: "bar",
            stack: '利润',
            data: this.zylrList,
            barWidth: 15,
            itemStyle: {
              normal: {
                color: "#477aff"
              }
            }
          },
          {
            name: "门诊药品利润",
            type: "bar",
            stack: '利润',
            data: this.mzlrList,
            barWidth: 15,
            itemStyle: {
              normal: {
                color: "#5fc8f3"
              }
            }
          }
        ]
      });
      this.show = false;
    },

  },

  mounted () {

    // this.getTime();
    // this.turnover();
    // this.sales();
    // this.rate();
    // this.rate2();
    // //图表1
    // this.getTurnover();
    // //图表3
    // this.getSales();

  }
};
</script>

<style lang="less" scoped>
.main {
  min-height: 100vh;
  background: #fff;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 120px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 12px;
    /deep/.van-loading__text {
      color: #1989fa;
    }
  }
  .m-hd {
    position: relative;
    padding: 4vw 8vw;
    font-size: 16px;
    text-align: left;
    line-height: 1;
    .line {
      position: absolute;
      top: 50%;
      left: 3.4vw;
      transform: translateY(-50%);
      display: inline-block;
      width: 3px;
      height: 13px;
      background: #477aff;
    }
  }
  .numList {
    display: flex;
    margin-bottom: 4vw;
    padding: 6vw 0;
    background: #477aff;
    color: #fff;
    .num {
      margin-bottom: 4vw;
      font-size: 18px;
      line-height: 1;
    }
    .tt {
      font-size: 14px;
      color: #bbdefc;
      line-height: 1;
    }
    li:first-child {
      width: 54.8vw;
      border-right: 1px solid #bbdefc;
    }
    li:last-child {
      width: 45.2vw;
    }
  }
  .numList2 {
    display: flex;
    margin-bottom: 3vw;
    background: #477aff;
    color: #fff;
    line-height: 1;
    li {
      padding: 6.26vw 0 6.13vw;
      text-align: center;
    }
    .item {
      width: 29.06vw;
    }
    .item2 {
      width: 30.94vw;
      background: #92c619;
    }
    .item3 {
      width: 20vw;
    }
    .item4 {
      width: 20vw;
    }
    .num {
      margin-bottom: 4vw;
      font-size: 18px;
      line-height: 1;
    }
    .tt {
      font-size: 14px;
      color: #d5fcbb;
    }
  }
  .numList3 {
    margin-bottom: 4vw;
    padding: 3vw 0 0 0;
    border-bottom: 1px solid #dedede;
    line-height: 1;
    li {
      display: flex;
      text-align: center;
      margin-bottom: 6vw;
      .round {
        display: inline-block;
        // position: absolute;
        // top: 50%;
        // left: 0;
        // transform: translateY(-50%);
        width: 2vw;
        height: 2vw;
        margin-right: 2vw;
        border-radius: 50%;
      }
      .round1 {
        background: #5791e7;
      }
      .round2 {
        background: #5fc8f3;
      }
      .num {
        margin-bottom: 3vw;
        font-size: 18px;
      }
      .tt {
        position: relative;
        font-size: 14px;
        color: #989898;
      }
      .item1 {
        width: 40vw;
      }
      .item2 {
        width: 30vw;
      }
    }
  }
  #chart_3 {
    margin-bottom: 4vw;
  }
  .numList4 {
    display: flex;
    padding: 6vw 0;
    background: #477aff;
    color: #fff;
    .num {
      margin-bottom: 4vw;
      font-size: 18px;
      line-height: 1;
    }
    .tt {
      font-size: 14px;
      color: #bbdefc;
      line-height: 1;
    }
    li {
      flex: 1;
    }
  }
  /deep/.van-tabs__nav {
    padding-left: 1vw;
  }

  /deep/.van-tab {
    flex: inherit;
    margin-left: 2.4vw;
    padding: 2vw 5.6vw;
    background: #36b3dc;
    color: #bbdefc;
    border-radius: 8px 8px 0 0;
    border-right: none;
  }
  /deep/.van-tabs__nav--card {
    margin: 0;
    border: none;
  }
  /deep/.van-tab--active {
    background: #477aff !important;
    color: #fff;
  }
}
</style>




// WEBPACK FOOTER //
// src/spd/logistics/logReport.vue